// Mock data for LG Law Office - Spanish Version

export const firmInfoEs = {
  name: "LG Law Office",
  tagline: "Luchando por Sus Derechos",
  phone: "1(909)397-7260",
  email: "",
  address: {
    street: "P.O. Box 2769",
    city: "Pomona",
    state: "CA",
    zip: "91769",
    full: "P.O. Box 2769, Pomona, CA 91769"
  },
  hours: "Lunes - Viernes 8:00 am - 5:00 pm",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.0877890876!2d-117.75072!3d34.063287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2d6f9f5e5c8d%3A0x9f5e5c8d9f5e5c8d!2sPomona%2C%20CA%2091769!5e0!3m2!1sen!2sus!4v1234567890!5m2!1sen!2sus"
};

export const practiceAreasEs = [
  {
    id: 1,
    title: "Compensación Laboral",
    slug: "workers-compensation",
    icon: "Briefcase",
    iconImage: "https://customer-assets.emergentagent.com/job_lglaw-injury/artifacts/brfanqjr_first-aid-support-accident-at-work-of-worker-at-fa-2026-01-11-11-01-31-utc.jpg",
    shortDescription: "¿Lesionado en el trabajo? Le ayudamos a obtener la compensación que merece.",
    fullDescription: "Si ha sido lesionado en el trabajo, la ley de California le otorga derecho a beneficios de compensación laboral. Estos beneficios pueden cubrir gastos médicos, salarios perdidos, costos de rehabilitación y pagos por discapacidad. Nuestro equipo experimentado lo guiará a través del complejo proceso de reclamaciones, asegurando que reciba la máxima compensación. Manejamos casos de accidentes laborales, lesiones por estrés repetitivo, enfermedades ocupacionales y padecimientos relacionados con el trabajo. No permita que su empleador o su compañía de seguros le niegue los beneficios que se ha ganado.",
    image: "https://images.unsplash.com/photo-1633158832532-f71e9c7ac6d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw2fHxpbmp1cnl8ZW58MHx8fHwxNzY4NDk2NzI0fDA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Evaluación gratuita",
      "Sin costos iniciales",
      "Máxima compensación",
      "Manejo experto de reclamaciones"
    ]
  },
  {
    id: 2,
    title: "Lesiones Personales",
    slug: "personal-injury",
    icon: "Heart",
    iconImage: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400&h=300&fit=crop",
    shortDescription: "¿Lesionado por negligencia ajena? Déjenos luchar por usted.",
    fullDescription: "Los casos de lesiones personales surgen cuando usted resulta herido debido a la negligencia o acciones intencionales de otra persona. Ya sea una caída, mordedura de perro o caso de responsabilidad de propietario, usted merece compensación por sus facturas médicas, ingresos perdidos, dolor y sufrimiento, y angustia emocional. Nuestra firma ha representado exitosamente a innumerables clientes en casos de lesiones personales, asegurando millones en acuerdos y veredictos. Investigamos exhaustivamente cada caso, trabajamos con expertos médicos y construimos argumentos convincentes para maximizar su recuperación.",
    image: "https://images.unsplash.com/flagged/photo-1569948807383-bc995c4f6dd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxhY2NpZGVudHxlbnwwfHx8fDE3Njg0OTY3MTl8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Disponibilidad 24/7",
      "Historial comprobado",
      "Sin ganar, no cobra",
      "Representación agresiva"
    ]
  },
  {
    id: 3,
    title: "Accidentes Automovilísticos",
    slug: "auto-accidents",
    icon: "Car",
    iconImage: "https://images.unsplash.com/photo-1713623311317-d3c43a4be4cf?w=400&h=300&fit=crop",
    shortDescription: "¿Víctima de accidente automovilístico? Obtenga la compensación necesaria.",
    fullDescription: "Los accidentes automovilísticos pueden resultar en lesiones devastadoras, facturas médicas crecientes y salarios perdidos. La ley de California requiere que los conductores tengan seguro, pero las compañías de seguros a menudo intentan minimizar los pagos. Nuestros abogados de accidentes automovilísticos luchan contra las prácticas injustas de seguros. Manejamos todo tipo de accidentes de vehículos motorizados incluyendo choques de autos, accidentes de motocicleta, accidentes de camión y lesiones a peatones. Desde recopilar evidencia hasta negociar con ajustadores de seguros hasta llevar casos a juicio, estamos con usted en cada paso del camino.",
    image: "https://images.unsplash.com/photo-1713623311317-d3c43a4be4cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjYXIlMjBhY2NpZGVudCUyMGRhbWFnZXxlbnwwfHx8fDE3Njg0OTY3MDh8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Consulta gratuita",
      "Tratamos con seguros",
      "Acuerdo rápido",
      "Experiencia en juicios"
    ]
  },
  {
    id: 4,
    title: "Resbalones y Caídas",
    slug: "slip-and-fall",
    icon: "AlertTriangle",
    iconImage: "https://images.unsplash.com/photo-1516069677018-378515003435?w=400&h=300&fit=crop",
    shortDescription: "¿Lesionado en propiedad ajena? Pueden ser responsables de sus daños.",
    fullDescription: "Los propietarios tienen el deber legal de mantener instalaciones seguras. Cuando no reparan peligros como pisos mojados, escaleras rotas, mala iluminación o superficies irregulares, y alguien resulta herido, pueden ser responsables. Las lesiones por resbalones y caídas pueden ser graves, causando fracturas, lesiones en la cabeza, daño espinal y dolor crónico. Investigamos las circunstancias de su accidente, recopilamos evidencia de negligencia y responsabilizamos a los propietarios. Ya sea que su lesión ocurrió en una tienda, restaurante, edificio de oficinas o propiedad privada, podemos ayudar.",
    image: "https://images.unsplash.com/photo-1516069677018-378515003435?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw1fHxpbmp1cnl8ZW58MHx8fHwxNzY4NDk2NzI0fDA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Investigación exhaustiva",
      "Expertos en responsabilidad",
      "Documentación médica",
      "Compensación completa"
    ]
  },
  {
    id: 5,
    title: "Accidentes de Uber/Lyft",
    slug: "rideshare-accidents",
    icon: "Smartphone",
    iconImage: "https://images.unsplash.com/photo-1673187139181-795761a40ca1?w=400&h=300&fit=crop",
    shortDescription: "¿Lesionado en un accidente de viaje compartido? Reglas especiales aplican.",
    fullDescription: "Los accidentes que involucran Uber, Lyft y otros servicios de transporte compartido implican cuestiones complejas de seguros y responsabilidad. Dependiendo de si el conductor estaba conectado a la aplicación, en camino a recoger un pasajero, o transportando un pasajero, pueden aplicar diferentes pólizas de seguro. Nuestros abogados entienden estas complejidades y saben cómo navegar las reclamaciones por accidentes de transporte compartido. Determinamos toda la cobertura de seguro disponible, identificamos a las partes responsables y buscamos la máxima compensación por sus lesiones. No deje que las compañías de transporte compartido minimicen su reclamación – luchamos por una recuperación completa y justa.",
    image: "https://images.unsplash.com/photo-1673187139181-795761a40ca1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxjYXIlMjBhY2NpZGVudCUyMGRhbWFnZXxlbnwwfHx8fDE3Njg0OTY3MDh8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Experiencia en seguros",
      "Reclamaciones múltiples",
      "Respuesta rápida",
      "Máxima recuperación"
    ]
  },
  {
    id: 6,
    title: "Mordeduras de Perro",
    slug: "dog-bites",
    icon: "AlertTriangle",
    iconImage: "https://customer-assets.emergentagent.com/job_lglaw-injury/artifacts/8mid5zzm_closeup-of-the-black-german-shepherd-barking-2026-01-07-07-24-33-utc.jpg",
    shortDescription: "¿Víctima de mordedura de perro? California responsabiliza estrictamente a los dueños.",
    fullDescription: "California tiene leyes de responsabilidad estricta para mordeduras de perro, lo que significa que los dueños de perros son responsables de las lesiones que sus perros causan, independientemente del comportamiento pasado del perro o del conocimiento del dueño sobre la agresión. Las lesiones por mordedura de perro pueden ser graves, causando cicatrices permanentes, daño nervioso, infecciones y trauma psicológico. Los niños son particularmente vulnerables a ataques graves de perros. Nuestros abogados experimentados responsabilizan a los dueños negligentes y buscan compensación por gastos médicos, salarios perdidos, dolor y sufrimiento, y angustia emocional. Trabajamos con expertos médicos para documentar sus lesiones y asegurar que reciba compensación completa por daños físicos y psicológicos.",
    image: "https://customer-assets.emergentagent.com/job_lglaw-injury/artifacts/8mid5zzm_closeup-of-the-black-german-shepherd-barking-2026-01-07-07-24-33-utc.jpg",
    benefits: [
      "Experiencia en responsabilidad estricta",
      "Documentación médica",
      "Cobertura de tratamiento de cicatrices",
      "Apoyo psicológico"
    ]
  },
  {
    id: 7,
    title: "Discriminación Laboral",
    slug: "employment-discrimination",
    icon: "Users",
    iconImage: "https://images.unsplash.com/photo-1656291857126-16125a3a1951?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx3b3JrcGxhY2UlMjBkaXNjcmltaW5hdGlvbnxlbnwwfHx8fDE3Njg1MTMyOTZ8MA&ixlib=rb-4.1.0&q=85",
    shortDescription: "¿Enfrentando discriminación laboral? Protegemos sus derechos y luchamos por justicia.",
    fullDescription: "Las leyes de California y federales prohíben la discriminación basada en raza, color, religión, sexo, origen nacional, edad, discapacidad, orientación sexual, identidad de género y otras características protegidas. Si ha experimentado discriminación en contratación, promoción, salario, asignaciones de trabajo, terminación o cualquier otra decisión laboral, tiene derechos legales. Nuestros abogados de derecho laboral luchan contra prácticas discriminatorias y ayudan a las víctimas a recuperar compensación por salarios perdidos, angustia emocional y daños punitivos. También manejamos reclamaciones de represalia cuando los empleadores castigan a los trabajadores por reportar discriminación o participar en investigaciones. No deje que la discriminación quede sin respuesta – estamos aquí para proteger sus derechos.",
    image: "https://images.unsplash.com/photo-1656291857126-16125a3a1951?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx3b3JrcGxhY2UlMjBkaXNjcmltaW5hdGlvbnxlbnwwfHx8fDE3Njg1MTMyOTZ8MA&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Experiencia en ley federal y estatal",
      "Protección contra represalias",
      "Recuperación de salarios perdidos",
      "Daños punitivos"
    ]
  },
  {
    id: 8,
    title: "Acoso Sexual",
    slug: "sexual-harassment",
    icon: "Shield",
    iconImage: "https://images.unsplash.com/photo-1625480857953-700f9cac1582?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxoYXJhc3NtZW50fGVufDB8fHx8MTc2ODUxMzMwM3ww&ixlib=rb-4.1.0&q=85",
    shortDescription: "¿Acoso sexual en el trabajo? Luchamos para proteger su dignidad y derechos.",
    fullDescription: "El acoso sexual en el lugar de trabajo es ilegal e inaceptable. Ya sea que esté experimentando acoso quid pro quo (donde los beneficios laborales están condicionados a favores sexuales) o acoso por ambiente hostil (conducta sexual no deseada que crea un lugar de trabajo intimidante u ofensivo), tiene protecciones legales. La ley de California proporciona remedios fuertes para las víctimas de acoso sexual, incluyendo compensación por angustia emocional, salarios perdidos y daños punitivos contra empleadores que no previenen o abordan el acoso. Nuestros abogados manejan los casos con sensibilidad y discreción mientras buscan agresivamente la justicia. También protegemos contra represalias cuando reporta acoso. Usted merece un lugar de trabajo seguro – permítanos ayudarle a defenderse.",
    image: "https://images.unsplash.com/photo-1625480857953-700f9cac1582?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxoYXJhc3NtZW50fGVufDB8fHx8MTc2ODUxMzMwM3ww&ixlib=rb-4.1.0&q=85",
    benefits: [
      "Manejo confidencial",
      "Reclamaciones de ambiente hostil",
      "Casos quid pro quo",
      "Defensa contra represalias"
    ]
  }
];

export const caseResultsEs = [
  { amount: '$850,000', type: 'Compensación Laboral', description: 'Lesión en sitio de construcción' },
  { amount: '$625,000', type: 'Accidente Automovilístico', description: 'Colisión de múltiples vehículos' },
  { amount: '$475,000', type: 'Resbalón y Caída', description: 'Negligencia en propiedad comercial' },
  { amount: '$390,000', type: 'Accidente de Rideshare', description: 'Acuerdo por accidente de Uber' }
];

export const testimonialsEs = [
  {
    id: 1,
    name: "María Rodríguez",
    case: "Compensación Laboral",
    rating: 5,
    text: "Después de mi lesión laboral, no sabía a dónde acudir. Lionel Girón y su equipo se encargaron de todo. Lucharon por mis beneficios mientras yo me enfocaba en recuperarme. Recibí compensación completa por mis gastos médicos y salarios perdidos. ¡Altamente recomendado!",
    date: "2024-11"
  },
  {
    id: 2,
    name: "Santiago Torres",
    case: "Accidente Automovilístico",
    rating: 5,
    text: "Me chocaron por detrás y la compañía de seguros intentó ofrecerme muy poco. LG Law Office intervino y consiguió un acuerdo que fue el triple de lo que el seguro ofrecía inicialmente. Profesionales, atentos y realmente se preocupan por sus clientes.",
    date: "2024-10"
  },
  {
    id: 3,
    name: "Carmen Jiménez",
    case: "Resbalón y Caída",
    rating: 5,
    text: "¡Excelente representación legal! Me resbalé en un piso mojado en una tienda y sufrí una lesión grave en la espalda. La tienda negó responsabilidad, pero la investigación exhaustiva del Sr. Girón probó su negligencia. Recibí un acuerdo justo que cubrió todos mis gastos.",
    date: "2024-09"
  },
  {
    id: 4,
    name: "Roberto Martínez",
    case: "Accidente de Uber",
    rating: 5,
    text: "Mi conductor de Uber se pasó un semáforo en rojo y nos chocaron. La situación del seguro era confusa, pero LG Law Office lo manejó perfectamente. Trataron con múltiples compañías de seguros y obtuvieron compensación completa. No podría haberlo hecho sin ellos.",
    date: "2024-08"
  }
];
